import {
  FETCH_ALL_ADMIN,
  FETCH_ALL_ADMIN_FAILED,
  FETCH_ALL_ADMIN_SUCCEED,
  ON_CREATE_ADMIN,
  ON_CREATE_ADMIN_SUCCEED,
  ON_CREATE_ADMIN_FAILED,
  FETCH_ADMIN_LOGIN_HISTORY,
  FETCH_ADMIN_LOGIN_HISTORY_SUCCEED,
  FETCH_ADMIN_LOGIN_HISTORY_FAILED,
  GET_ROLE_FOR_USER,
  POST_ROLE_FOR_USER,
  FETCH_AUTH_INFO,
  FETCH_AUTH_INFO_SUCCEED,
  FETCH_AUTH_INFO_FAILED,
  FETCH_ADMIN_BALANCES,
  FETCH_ADMIN_BALANCES_SUCCEED,
  FETCH_ADMIN_BALANCES_FAILED,
  FETCH_ADMIN_INFO,
  FETCH_ADMIN_INFO_FAILED,
  FETCH_ADMIN_INFO_SUCCEED,
  FETCH_LIMIT_WITHDRAWAL_OF_ADMIN,
  FETCH_LIMIT_WITHDRAWAL_OF_ADMIN_FAILED,
  FETCH_LIMIT_WITHDRAWAL_OF_ADMIN_SUCCEED,
  SET_LIMIT_WITHDRAWAL_FOR_ADMIN,
  SET_LIMIT_WITHDRAWAL_FOR_ADMIN_SUCCEED,
  SET_LIMIT_WITHDRAWAL_FOR_ADMIN_FAILED,
  FETCH_ADMINS,
  FETCH_ADMINS_SUCCEED,
  FETCH_ADMINS_FAILED,
  FETCH_BAN_ADMIN,
  FETCH_UN_BAN_ADMIN,
  FETCH_OWN_BALANCE,
  FETCH_OWN_BALANCE_FAILED,
  FETCH_OWN_BALANCE_SUCCESS,
  FETCH_DEL_ADMIN,
} from './action_types';

export default {
  onFetchAllAdmin: (data) => ({
    type: FETCH_ALL_ADMIN,
    params: {
      data,
    },
  }),
  onFetchAllAdminSucceed: (data) => ({
    type: FETCH_ALL_ADMIN_SUCCEED,
    data,
  }),
  onFetchAllAdminFailed: (err) => ({
    type: FETCH_ALL_ADMIN_FAILED,
    err,
  }),
  onFetchAdmins: (data) => ({
    type: FETCH_ADMINS,
    params: {
      data,
    },
  }),
  onFetchAdminsSucceed: (data) => ({
    type: FETCH_ADMINS_SUCCEED,
    data,
  }),
  onFetchAdminsFailed: (err) => ({
    type: FETCH_ADMINS_FAILED,
    err,
  }),
  onCreateAdmin: (params, callback) => ({
    type: ON_CREATE_ADMIN,
    params,
    callback,
  }),
  onCreateAdminSucceed: (data) => ({
    type: ON_CREATE_ADMIN_SUCCEED,
    data,
  }),
  onCreateAdminFailed: (err) => ({
    type: ON_CREATE_ADMIN_FAILED,
    err,
  }),
  onFetchAdminLoginHistory: (params) => ({
    type: FETCH_ADMIN_LOGIN_HISTORY,
    params,
  }),
  onFetchAdminLoginHistorySucceed: (data) => ({
    type: FETCH_ADMIN_LOGIN_HISTORY_SUCCEED,
    data,
  }),
  onFetchAdminLoginHistoryFailed: (err) => ({
    type: FETCH_ADMIN_LOGIN_HISTORY_FAILED,
    err,
  }),
  onFetchAuthInfo: (params) => ({
    type: FETCH_AUTH_INFO,
    params,
  }),
  onFetchAuthInfoSucceed: (data) => ({
    type: FETCH_AUTH_INFO_SUCCEED,
    data,
  }),
  onFetchAuthInfoFailed: (err) => ({
    type: FETCH_AUTH_INFO_FAILED,
    err,
  }),

  getRoleByPubkey: (pubkey, callback) => ({
    type: GET_ROLE_FOR_USER,
    params: {
      pubkey,
    },
    callback,
  }),
  postRoleForUser: (body, callback) => ({
    type: POST_ROLE_FOR_USER,
    params: body,
    callback,
  }),

  onFetchAdminInfo: (params) => ({
    type: FETCH_ADMIN_INFO,
    params,
  }),
  onFetchAdminInfoSucceed: (data) => ({
    type: FETCH_ADMIN_INFO_SUCCEED,
    data,
  }),
  onFetchAdminInfoFailed: (err) => ({
    type: FETCH_ADMIN_INFO_FAILED,
    err,
  }),

  fetchLimitWithdrawalOfAdminAction: (params) => ({
    type: FETCH_LIMIT_WITHDRAWAL_OF_ADMIN,
    params,
  }),
  fetchLimitWithdrawalOfAdminSucceedAction: (data, coins) => ({
    type: FETCH_LIMIT_WITHDRAWAL_OF_ADMIN_SUCCEED,
    data,
    coins,
  }),
  fetchLimitWithdrawalOfAdminFailedAction: (err) => ({
    type: FETCH_LIMIT_WITHDRAWAL_OF_ADMIN_FAILED,
    err,
  }),

  setLimitWithdrawalForAdminAction: (params, callback) => ({
    type: SET_LIMIT_WITHDRAWAL_FOR_ADMIN,
    params,
    callback,
  }),
  setLimitWithdrawalForAdminSucceedAction: (data) => ({
    type: SET_LIMIT_WITHDRAWAL_FOR_ADMIN_SUCCEED,
    params: {
      data,
    },
  }),
  setLimitWithdrawalForAdminFailedAction: (err) => ({
    type: SET_LIMIT_WITHDRAWAL_FOR_ADMIN_FAILED,
    err,
  }),

  fetchAdminBalancesAction: (data) => ({
    type: FETCH_ADMIN_BALANCES,
    params: {
      data,
    },
  }),
  fetchAdminBalancesSucceedAction: (data) => ({
    type: FETCH_ADMIN_BALANCES_SUCCEED,
    params: {
      data,
    },
  }),
  fetchAdminBalancesFailedAction: (data) => ({
    type: FETCH_ADMIN_BALANCES_FAILED,
    params: {
      data,
    },
  }),
  onBanAdmin: (data, callback) => ({
    type: FETCH_BAN_ADMIN,
    params: {
      data,

    },
    callback,
  }),

  onUnBanAdmin: (data, callback) => ({
    type: FETCH_UN_BAN_ADMIN,
    params: {
      data,

    },
    callback,
  }),

  onDelAdmin: (params, callback) => ({
    type: FETCH_DEL_ADMIN,
    params,
    callback,
  }),

  fetchOwnBalance: () => ({
    type: FETCH_OWN_BALANCE,
  }),
  fetchOwnBalanceSuccess: (data) => ({
    type: FETCH_OWN_BALANCE_SUCCESS,
    data,
  }),
  fetchOwnBalanceFailed: (err) => ({
    type: FETCH_OWN_BALANCE_FAILED,
    err,
  }),
};
